import { dispatchAmplitudeEvent } from './dispatchAmplitudeEvent'

function trackDyCampaigns(): boolean {
  const { DYO, amplitude } = window

  if (!DYO?.getUserObjectsAndVariations || !amplitude?.track) {
    return false
  }

  if (!window.__dyAmplitudeSentEvents) {
    window.__dyAmplitudeSentEvents = {}
  }

  const sentEvents = window.__dyAmplitudeSentEvents

  const items: DYVariation[] = DYO.getUserObjectsAndVariations() || []

  if (items.length === 0) return false

  items.forEach((item) => {
    if (
      !item?.objectName ||
      !item?.conditionName ||
      !item?.variations?.length
    ) {
      return
    }

    const [variationName] = item.variations
    const variationId = item.variationIds?.[0] ?? 'no_variation_id'

    const dedupeKey = [
      item.objectId ?? 'no_object_id',
      item.conditionId ?? 'no_condition_id',
      variationId,
    ].join('_')

    if (sentEvents[dedupeKey]) return

    sentEvents[dedupeKey] = true

    dispatchAmplitudeEvent({
      eventName: 'Dynamic Yield Campaign Viewed',
      eventData: {
        'Campaign Name': item.objectName,
        'Experience Name': item.conditionName,
        'Variation Name': variationName,
      },
    })
  })

  return true
}

export function exposeDYCampaingsOnAmplitude() {
  let attempts = 0
  const MAX_ATTEMPTS = 20

  try {
    const initialTry = trackDyCampaigns()

    if (initialTry) return

    const interval = setInterval(() => {
      attempts++

      const success = trackDyCampaigns()

      if (success || attempts >= MAX_ATTEMPTS) {
        clearInterval(interval)
      }
    }, 500)
  } catch {
    console.error('Failed to sync DY events into amplitude')
  }
}
